import React, { useEffect } from 'react'
import { imanager } from '../visualization/imanager'
import './Widget.css'

function InteractionManager() {

    useEffect(() => {
        const im = imanager().element('im')

        im.execute()
            .catch(() => {
                console.log(`There was an error with the interaction manager`)
            })
        im.get('api').updateContent()
    }, [])

    return (
        <div className="im">
            <div 
                className="im-body"
                id="im"
            ></div>
        </div>
    )
}

export default InteractionManager
